const baseURLTest = 'https://interface-test.voghion.com' //测试
const baseURLPre = 'https://pre-interface.voghion.com' //pre，后续会废弃
const baseURLGray = 'https://interface-gray.voghion.com' //灰度
const baseURLProd = 'https://interface.voghion.sg' //线上

const IMbaseURLTest = 'https://interface-test.voghion.com' // IM-测试
const IMbaseURLGray = 'https://interface-gray.voghion.com' // IM-灰度
const IMbaseURLProd = 'https://interface.voghion.com' // IM-线上

const baseWebsocketURLTest = 'vog-im-test.voghion.com'
const baseWebsocketURLGray = 'vog-im-gray.voghion.com'
const baseWebsocketURLProd = 'vog-im.voghion.com'

const feedBackURLTest = 'https://static-test.voghion.com/static/user-center/index.html#/feedback'
const feedBackURLGray = 'https://static-gray.voghion.com/static/user-center/index.html#/feedback'
const feedBackURLProd = 'https://static.voghion.com/static/user-center/v0/index.html#/feedback'

const uploadDomainTest = 'https://tools-gray.voghion.com/buss-common/upload/fileInfo'
const uploadDomainGray = 'https://tools-gray.voghion.com/buss-common/upload/im/file'
const uploadDomainProd = 'https://pre-tools.voghion.com/buss-common/upload/im/file'

const envTest = 'test'
const envPre = 'pre'
const envGray = 'gray'
export const envProd = 'prod'

const domainEnvs = [envTest, envPre, envGray]
const envPrefix = 'env-'

export function getAppEnv() {
  if (process.env.NODE_ENV !== 'production') {
    // return envGray
    return envTest
  }
  // 从域名获取环境
  const hostname = location.hostname
  const subname = hostname.split('.')[0]
  if (subname.includes('-')) {
    const tag = subname.split('-')[1]
    if (domainEnvs.includes(tag)) {
      return tag
    }
  }
  // 从路径获取环境
  const pathname = location.pathname
  if (pathname.startsWith(`/${envPrefix}`)) {
    const arr = pathname.split('/')
    const env = arr[1].replace(envPrefix, '')
    return env
  }
  return envProd
}

export function isProd() {
  return getAppEnv() === envProd
}

export function getEnvBaseURL() {
  const appEnv = getAppEnv()
  switch (appEnv) {
    case envTest:
      return baseURLTest
    case envPre:
      return baseURLPre
    case envGray:
      return baseURLGray
  }
  return baseURLProd
}

export function getEnvIMbaseURL() {
  const appEnv = getAppEnv()
  switch (appEnv) {
    case envTest:
      return IMbaseURLTest
    case envPre:
      return IMbaseURLProd
    case envGray:
      return IMbaseURLGray
  }
  return IMbaseURLProd
}

export function getEnvImURL() {
  const appEnv = getAppEnv()
  switch (appEnv) {
    case envTest:
      return baseWebsocketURLTest
    case envGray:
      return baseWebsocketURLGray
  }
  return baseWebsocketURLProd
}

/**
 * 获取反馈地址
 * @returns
 */
export function getFeedBackUrl() {
  const appEnv = getAppEnv()
  switch (appEnv) {
    case envTest:
      return feedBackURLTest
    case envGray:
      return feedBackURLGray
  }
  return feedBackURLProd
}

/**
 * 获取上传地址
 * @returns
 */
export function getUploadDomain() {
  const appEnv = getAppEnv()
  switch (appEnv) {
    case envTest:
      return uploadDomainTest
    case envGray:
      return uploadDomainGray
  }
  return uploadDomainProd
}

/**
 * 是否是测试环境
 * @returns
 */
export function isEnvTest() {
  return getAppEnv() === envTest
}

export function isEnvProd() {
  return getAppEnv() === envProd
}

export function isEnvGray() {
  return getAppEnv() === envGray
}
